import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ContinentDto } from '@cradua/data';
import Swal from 'sweetalert2';


@Component({
  selector: 'cradua-continent',
  templateUrl: './continent.component.html',
  styleUrls: ['./continent.component.scss']
})
export class ContinentComponent implements OnChanges {


  continentForm: FormGroup;
  continentFormArray: FormGroup;
  control = new FormControl();
  @Input() continents: ContinentDto[];
  @Output() continent = new EventEmitter<ContinentDto[]>()
  @Output() deleteContinentEvent = new EventEmitter<any>()

    selectedContinent: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createContinentForm();
    }

    createContinentForm() {
      this.continentForm = this.fb.group({
        ContinentName: ['', Validators.required],
        id: null
        });
        this.continentFormArray = this.fb.group({ Continents: this.fb.array([])
          });
        this.setContinent();
    }

  // method to display continents
  setContinent() {
    const control  = this.continentFormArray.controls.Continents as FormArray;
    this.continents.forEach( e => {
      control.push(
        this.fb.group({
          ContinentName: e.ContinentName,
          id: e.id
        })
      );
    });
  }


  // method to add Continent
  addContinent(value: ContinentDto) {
    const control  = this.continentFormArray.controls.Continents as FormArray;
    control.insert(0,
          this.fb.group({
            ContinentName: value.ContinentName,
            id: null
          })
       );
  }

  selectContinent(value) {}

  // method to delete continent from arrary list
  deleteContinent(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.continentFormArray.controls.Continents as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.continents.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.continents[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: ContinentDto) {
    if(this.continentForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.continentFormArray.get('Continents')['controls'][this.selectedIndex].patchValue({ContinentName: formValue.ContinentName});
    } else {
      this.addContinent(formValue);
    }
    this.selectedIndex = null;
    this.continentForm.reset()
  }

  onEdit(index, value: ContinentDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.continentForm.patchValue({ContinentName: value.ContinentName});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.continentForm.reset();
  }

  onSubmit(formValue: ContinentDto[]) {
  this.continent.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteContinentEvent.emit(this.filteredDelete);
  }
  }

}
